// Source is session-scoped, coarse, and stored only after analytics consent.
// Never collect search terms, full referrers, form fields or application events.
const KEY = "uo_organic_landing";
const SEARCH_HOSTS = /^(?:[a-z0-9-]+\.)?(?:google\.[a-z.]+|bing\.com|duckduckgo\.com|search\.yahoo\.com|ecosia\.org)$/i;

function consented(): boolean {
  try {
    return JSON.parse(localStorage.getItem("cookie_consent") || "{}").analytics === true;
  } catch {
    return false;
  }
}

export function rememberOrganicLanding(): void {
  if (!consented()) {
    try { sessionStorage.removeItem(KEY); } catch { /* blocked storage */ }
    return;
  }
  if (!document.referrer) return;
  try {
    const origin = new URL(document.referrer);
    if (origin.origin !== location.origin && SEARCH_HOSTS.test(origin.hostname)) {
      sessionStorage.setItem(KEY, "organic_search");
    }
  } catch {
    // Malformed or inaccessible referrer: no attribution.
  }
}

export function trackOrganicContactSuccess(service: string): void {
  if (!consented()) return;
  try {
    if (sessionStorage.getItem(KEY) !== "organic_search" || typeof window.gtag !== "function") return;
    // Only successful contact requests. Not a second generate_lead event.
    window.gtag("event", "organic_contact_success", { service, source_type: "organic_search" });
  } catch {
    // Analytics must never interrupt the form result.
  }
}